module.exports = __webpack_public_path__ + "static/heylikey-fdb326b98554de561358933abd5f02f5.mp4";